module.exports = {
    fulfilmentMethod: {
        pickupOptionName: 'Pick Up',
        deliveryOptionName: 'Delivery',
        noneOptionName: 'Choose later',
        pickupOptionSubheading: '$30 minimum spend',
        deliveryOptionSubheading: '$50 minimum spend',
        expressDeliveryOptionSubheading: '$0 minimum spend',
        noneOptionSubheading: '',
        pickupOptionMessage: 'to collect my groceries',
        deliveryOptionMessage: 'my groceries delivered',
        noneOptionMessage: 'to choose later',
        questionnaireHeading: 'Delivery or Collection?',
        timetablePickupName: 'pickup',
        showDeliveryHint: true,
        deliveryHintText: 'A variable minimum spend may apply',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/fulfilment-method.js